<template>	
  <b-container fluid v-if="formModel != null">
      <b-row>
          <b-col class="card-form-primary">
            <b-row align-h="between" style="cursor:pointer;" @click="expandLiqForm(isLiqFormCollapse)">
                <b-col class="mt-3 mb-2" cols="9">
                    <h5 style="color: #312bb5"><b-icon icon="layout-sidebar-inset"/> {{formModel.itemSelected}}</h5>
                </b-col>
                <b-col class="mt-3" cols="2" md="1" v-if="isLiqFormCollapse">
                    <b-icon style="color: #2A59B7;" font-scale="1.3" shift-v="-3" icon="chevron-compact-down" />
                </b-col>
                <b-col class="mt-3" cols="2" md="1" v-if="!isLiqFormCollapse">
                    <b-icon style="color: #2A59B7; " font-scale="1.3" shift-v="-3" icon="chevron-compact-up" />
                </b-col>
            </b-row>
            <b-row v-if="!isLiqFormCollapse">
                <b-col class="ml-4 mr-4 mb-3">
                    <b-form-row>
                        <b-col cols="12" >
                            <b-form-group v-if="formModel.inTxtNombre.title != ''" :label="formModel.inTxtNombre.title">
                                <b-form-input size="sm" :state="!$v.formModel.inTxtNombre.$invalid" type="text" v-model.trim="$v.formModel.inTxtNombre.model.$model" @change="cleanResults" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inTxtNombre.model.minLength">El Nombre no puede estar vacio</div>
                                <div class="error" v-if="!$v.formModel.inTxtNombre.model.maxLength">El Nombre es demasiado largo</div>
                                <div class="error" v-if="!$v.formModel.inTxtNombre.model.alphaplus">Este campo no admite caracteres especiales</div>
                                <div class="error" v-if="!$v.formModel.inTxtNombre.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="4">
                            <b-form-group  v-if="formModel.inTxt1.title != ''" :label="formModel.inTxt1.title">
                                <b-form-input size="sm" :state="!$v.formModel.inTxt1.$invalid" type="text" v-model.trim="$v.formModel.inTxt1.model.$model" @change="cleanResults"></b-form-input>
                                <div class="error" v-if="!$v.formModel.inTxt1.model.minLength">Clave Catastral incorrecta.</div>
                                <div class="error" v-if="!$v.formModel.inTxt1.model.maxLength">Clave Catastral incorrecta.</div>
                                <div class="error" v-if="!$v.formModel.inTxt1.model.required">Este campo es obligatorio.</div>                
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="4">
                            <b-form-group  v-if="formModel.inTxt2.title != ''" :label="formModel.inTxt2.title">
                                <b-form-input size="sm" :state="!$v.formModel.inTxt2.$invalid" type="text" v-model.trim="$v.formModel.inTxt2.model.$model" @change="cleanResults"></b-form-input>
                                
                                <div class="error" v-if="!$v.formModel.inTxt2.model.minLength">Clave de contribuyente incorrecta.</div>
                                <div class="error" v-if="!$v.formModel.inTxt2.model.maxLength">Clave de contribuyente incorrecta.</div>
                                <div class="error" v-if="!$v.formModel.inTxt2.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="4">
                            <b-form-group  v-if="formModel.inTxt3.title != ''" :label="formModel.inTxt3.title">
                                <b-form-input size="sm" :state="!$v.formModel.inTxt3.$invalid" type="text" v-model.trim="$v.formModel.inTxt3.model.$model" @change="cleanResults"></b-form-input>
                                <div class="error" v-if="!$v.formModel.inTxt3.model.minLength">Número de Cuenta incorrecto.</div>
                                <div class="error" v-if="!$v.formModel.inTxt3.model.maxLength">Número de Cuenta incorrecto.</div>
                                <div class="error" v-if="!$v.formModel.inTxt3.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>        
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="4">
                            <b-form-group  v-if="formModel.inTxt4.title != ''" :label="formModel.inTxt4.title">
                                <b-form-input size="sm" :state="!$v.formModel.inTxt4.$invalid" type="text" v-model.trim="$v.formModel.inTxt4.model.$model" @change="cleanResults"></b-form-input>
                                <div class="error" v-if="!$v.formModel.inTxt4.model.alphaNum">Número de folio incorrectos.</div>
                                <div class="error" v-if="!$v.formModel.inTxt4.model.minLength">Número de folio incorrecto.</div>
                                <div class="error" v-if="!$v.formModel.inTxt4.model.maxLength">Número de folio incorrecto.</div>
                                <div class="error" v-if="!$v.formModel.inTxt4.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>        
                    </b-form-row>

                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group  v-if="formModel.inTxt5.title != ''" :label="formModel.inTxt5.title">
                                <b-form-input size="sm"  type="text" v-model.trim="formModel.inTxt5.model" @change="cleanResults"></b-form-input>
                                
                            </b-form-group>
                        </b-col>        
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group  v-if="formModel.inTxt6.title != ''" :label="formModel.inTxt6.title">
                                <b-form-input size="sm"  type="text" v-model.trim="formModel.inTxt6.model" @change="cleanResults"></b-form-input>
                                
                            </b-form-group>
                        </b-col>        
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group  v-if="formModel.inTxt7.title != ''" :label="formModel.inTxt7.title">
                                <b-form-input size="sm"  type="text" v-model.trim="formModel.inTxt7.model" @change="cleanResults"></b-form-input>
                                
                            </b-form-group>
                        </b-col>        
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group  v-if="formModel.inTxt8.title != ''" :label="formModel.inTxt8.title">
                                <b-form-input size="sm"  type="text" v-model.trim="formModel.inTxt8.model" @change="cleanResults"></b-form-input>
                                
                            </b-form-group>
                        </b-col>        
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group  v-if="formModel.inTxt9.title != ''" :label="formModel.inTxt9.title">
                                <b-form-input size="sm"  type="text" v-model.trim="formModel.inTxt9.model" @change="cleanResults"></b-form-input>
                                
                            </b-form-group>
                        </b-col>        
                    </b-form-row> 




                    <b-form-row>
                        <b-col cols="12" lg="6">
                            <b-form-group   v-if="formModel.selectA.title != ''" :label="formModel.selectA.title">
                                <b-form-select size="sm" v-model="formModel.selectA.model" :options="formModel.selectA.options" @change="configFromSelectA();" ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="3" v-if="formModel.select1.title != ''">
                            <b-form-group   :label="formModel.select1.title">
                                <b-form-select size="sm" v-model="formModel.select1.model" :options="formModel.select1.options"  ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="3" v-if="formModel.select2.title != ''">
                            <b-form-group   :label="formModel.select2.title">
                                <b-form-select  size="sm" v-model="formModel.select2.model"  :options="formModel.select2.options"  ></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="3" v-if="formModel.select3.title != ''">
                            <b-form-group   :label="formModel.select3.title">
                                <b-form-select  size="sm" v-model="formModel.select3.model"  :options="formModel.select3.options" ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="4">
                            <b-form-group v-if="formModel.inNum1.title != ''" :label="formModel.inNum1.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum1.$invalid" type="number" v-model.trim="$v.formModel.inNum1.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum1.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum1.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum2.title != ''" :label="formModel.inNum2.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum2.$invalid" type="number" v-model.trim="$v.formModel.inNum2.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum2.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum2.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum3.title != ''" :label="formModel.inNum3.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum3.$invalid" type="number" v-model.trim="$v.formModel.inNum3.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum3.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum3.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum4.title != ''" :label="formModel.inNum4.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum4.$invalid" type="number" v-model.trim="$v.formModel.inNum4.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum4.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum4.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum5.title != ''" :label="formModel.inNum5.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum5.$invalid" type="number" v-model.trim="$v.formModel.inNum5.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum5.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum5.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum6.title != ''" :label="formModel.inNum6.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum6.$invalid" type="number" v-model.trim="$v.formModel.inNum6.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum6.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum6.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum7.title != ''" :label="formModel.inNum7.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum7.$invalid" type="number" v-model.trim="$v.formModel.inNum7.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum7.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum7.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum8.title != ''" :label="formModel.inNum8.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum8.$invalid" type="number" v-model.trim="$v.formModel.inNum8.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum8.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum8.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum9.title != ''" :label="formModel.inNum9.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum9.$invalid" type="number" v-model.trim="$v.formModel.inNum9.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum9.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum9.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum11.title != ''" :label="formModel.inNum11.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum11.$invalid" type="number" v-model.trim="$v.formModel.inNum11.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum11.model.between">El valor esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inNum11.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="3">
                            <b-form-group v-if="formModel.inDate1.title != ''" :label="formModel.inDate1.title">
                                <b-form-input size="sm" :state="!$v.formModel.inDate1.$invalid" type="date" v-model="$v.formModel.inDate1.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inDate1.model.minValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inDate1.model.maxValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inDate1.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="3">
                            <b-form-group v-if="formModel.inDate2.title != ''" :label="formModel.inDate2.title">
                                <b-form-input size="sm" :state="!$v.formModel.inDate2.$invalid" type="date" v-model="formModel.inDate2.model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inDate2.model.minValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inDate2.model.maxValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.inDate2.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.chkBox1.title != ''" :label="formModel.chkBox1.title">
                            <b-form-checkbox v-model="formModel.chkBox1.model" @change="cleanResults"  >  </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="2">
                            <b-form-group v-if="formModel.inNum10.title != ''" :label="formModel.inNum10.title">
                                <b-form-input size="sm" :state="!$v.formModel.inNum10.$invalid" type="number" v-model.trim="$v.formModel.inNum10.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.inNum10.model.between">Debe ingresar una cantidad entre 0 y 10.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="3">
                            <b-form-group v-if="formModel.fechaVencimiento.title != ''" :label="formModel.fechaVencimiento.title">
                                <b-form-input size="sm" :state="!$v.formModel.fechaVencimiento.$invalid" type="date" v-model="$v.formModel.fechaVencimiento.model.$model" ></b-form-input>
                                <div class="error" v-if="!$v.formModel.fechaVencimiento.model.minValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.fechaVencimiento.model.maxValue">La fecha esta fuera del rango.</div>
                                <div class="error" v-if="!$v.formModel.fechaVencimiento.model.required">Este campo es obligatorio.</div>
                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row v-if="formModel.itemSelected!='Orden de Pago' && formModel.itemSelected!='Subsidios' && formModel.itemSelected!='Integración IUSA' && formModel.itemSelected!='Transacciones TPV' && formModel.itemSelected!='Parquímetro' && formModel.itemSelected!='Saldo parquímetro' && formModel.itemSelected!='Parquímetro Validación' && formModel.itemSelected!='Registro Pagos Externos' && formModel.itemSelected!='Registro SIIGEM'">
                        <b-col cols="12" >
                            <b-form-group  label="Observaciones:">
                                <b-form-input size="sm" :state="!$v.formModel.inTxtObs.$invalid" type="text" v-model.trim="$v.formModel.inTxtObs.model.$model" @change="cleanResults"></b-form-input>
                                <div class="error" v-if="!$v.formModel.inTxtObs.model.maxLength">El texto es demasiado largo</div>
                                <div class="error" v-if="!$v.formModel.inTxtObs.model.alphaplus">Este campo no admite caracteres especiales</div>
                            </b-form-group><br>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="12" lg="8">  
                            <b-alert variant="danger" :show="msgErrorLiquidacion != null" dismissible>
                                {{msgErrorLiquidacion}}
                            </b-alert>
                        </b-col>
                    </b-form-row>
                    <b-form-row v-if="formModel.itemSelected!='Orden de Pago' && formModel.itemSelected!='Subsidios' && formModel.itemSelected!='Integración IUSA' && formModel.itemSelected!='Transacciones TPV' && formModel.itemSelected!='Parquímetro Validación' && formModel.itemSelected!='Registro Pagos Externos' && formModel.itemSelected!='Registro SIIGEM'" >
                        <b-col cols="12" lg="5" xl="4">
                            <b-dropdown  block split v-on:click="getLiquidacion(false, true)" variant="success" size="lg">
                                <template #button-content>
                                    <b-spinner v-if="isCalculando"></b-spinner>
                                    <strong v-if="isCalculando"> Calculando . . .</strong>
                                    <strong v-if="!isCalculando"> Calcular <b-icon icon="arrow-right-circle"/></strong>
                                </template>
                                <b-dropdown-item @click="getLiquidacion(false, false)">Calcular y agregar a la liquidación actual</b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-form-row>

                    <b-form-row v-if="formModel.itemSelected=='Orden de Pago'">
                        <b-col cols="12" lg="5" xl="4">
                            <b-button  block v-on:click="getLiquidacion(true, true)" variant="success" size="lg">
                                <b-spinner v-if="isCalculando"></b-spinner>
                                <strong v-if="isCalculando"> Cargando . . .</strong>
                                <strong v-if="!isCalculando"> Cargar <b-icon icon="arrow-right-circle"/></strong>
                            </b-button>
                        </b-col>
                    </b-form-row>

                    <b-row v-if="formModel.itemSelected=='Subsidios'">
                        <b-col>
                            <subsidios/>
                        </b-col>
                    </b-row>
                    
                    <b-row v-if="formModel.itemSelected=='Integración IUSA'">
                        <b-col>
                            <IntegraIUSA/>
                        </b-col>
                    </b-row>

                    <b-row v-if="formModel.itemSelected=='Transacciones TPV'">
                        <b-col>
                            <Transacciones3D/>
                        </b-col>
                    </b-row>

                    <b-row v-if="formModel.itemSelected=='Registro Pagos Externos'">
                        <b-col>
                            <PagoExterno/>
                        </b-col>
                    </b-row>

                    <b-row v-if="formModel.itemSelected=='Registro SIIGEM'">
                        <b-col>
                            <PagosSIIGEM/>
                        </b-col>
                    </b-row>

                    <b-row v-if="formModel.itemSelected=='Parquímetro Validación'">
                        <b-col>
                            <Parquimetro/>
                        </b-col>
                    </b-row>

                    <p>{{responseData}}</p>
                </b-col>
            </b-row>
        </b-col>
      </b-row>
  </b-container>
</template>

<script>
    import { minLength, alphaNum, maxLength, between, requiredIf, helpers } from 'vuelidate/lib/validators'
    import { mapState} from 'vuex'
    import { configFormFromSelectA } from '@/store/modules/cobro'
    import Subsidios from './Subsidios.vue'
    import IntegraIUSA from './IntegraIUSA.vue'
    import PagoExterno from './PagoExterno.vue'
    import PagosSIIGEM from './PagosSIIGEM.vue'
    import Transacciones3D from './Transacciones3D.vue'
import Parquimetro from './Parquimetro.vue'

    const alphaplus = helpers.regex('alphaplus', /^[-%,.&0-9a-zA-ZÀ-ÿ\u00f1\u00d1 /:]*$/)
    
    export default {
  components: { Subsidios, IntegraIUSA , Transacciones3D, PagoExterno, PagosSIIGEM, Parquimetro},
        data(){
            return{
                responseData : "",
            }
        },
        props:['getLiquidacion'],
        methods: {
            cleanResults (){
                if(!this.isCalculando & !this.isGenerando ){
                    this.$store.commit("clearResultsCobro");
                }
            },
            getLiquidacionForm(isOrden, nueva){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    this.getLiquidacion(isOrden, nueva, 99);
                }
            },
            expandLiqForm(is){
                this.$store.commit("updateIsLiqFormCollapse", !is)
            },  
            configFromSelectA(){
                configFormFromSelectA();
                //configInNum1TitleFor(this.$store);
            },
        },
        computed: mapState({
            formModel : state => state.cobro.formModel,
            tipoCatalogo : state => state.cobro.tipoCatalogo,
            isCalculando: state => state.cobro.isCalculando,
            isGenerando: state => state.cobro.isGenerando,
            isLiqFormCollapse : state => state.cobro.isLiqFormCollapse,
            liqForms: state => state.cobro.formsModels,
            token: state => state.login.token,
            msgErrorLiquidacion: state => state.cobro.msgErrorLiquidacion,
            
        }),
        validations: {
            formModel: {
                inTxtNombre:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inTxtNombre.title != ''}),
                        alphaplus,
                        minLength: minLength(1),
                        maxLength: maxLength(200)
                    }
                },
                inTxtObs:{
                    model:{
                        alphaplus,
                        maxLength: maxLength(499)
                    }
                },
                inTxt1: {
                    model:{
                        required: requiredIf(function() {return this.formModel.inTxt1.title != ''}),
                        //alphaNum,
                        minLength: minLength(1),
                        maxLength: maxLength(16)
                    }
                },
                inTxt2:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inTxt2.title != ''}),
                        //alphaNum,
                        minLength: minLength(1),
                        maxLength: maxLength(8)
                    }
                },
                inTxt3:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inTxt3.title != ''}),
                        //alphaNum,
                        minLength: minLength(1),
                        maxLength: maxLength(20)
                    }
                },
                inTxt4:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inTxt4.title != ''}),
                        alphaNum,
                        minLength: minLength(4),
                        maxLength: maxLength(9)
                    }
                },
                inNum1:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum1.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum2:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum2.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum3:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum3.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum4:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum4.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum5:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum5.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum6:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum6.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum7:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum7.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum8:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum8.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum9:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum9.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inNum10:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum10.title != ''}),
                        between: between(0, 10)
                    }
                },
                inNum11:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inNum11.title != ''}),
                        between: between(0, 999999999)
                    }
                },
                inDate1:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inDate1.title != ''}),
                        minValue: value => value > new Date(1999,0,1).toISOString(),
                        maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString()
                    }
                },
                inDate2:{
                    model:{
                        required: requiredIf(function() {return this.formModel.inDate2.title != ''}),
                        minValue: value => value > new Date(1999,0,1).toISOString(),
                        maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
                        
                    }
                },
                fechaVencimiento:{
                    model:{
                        required: requiredIf(function() {return this.formModel.fechaVencimiento.title != ''}),
                        minValue: value => value > new Date().toISOString(),
                        maxValue: value => value < new Date(new Date().getFullYear(),11,31).toISOString(),
                        
                    }
                },
            }
        }
    }
</script>
<style>
div.error    {color: red;}
</style>